/** Focus the Draw inspector text field (template insert, double-click). */
let focusTextContentFieldFn = null;

export const registerTextContentFieldFocus = (fn) => {
  focusTextContentFieldFn = typeof fn === 'function' ? fn : null;
};

export const focusTextContentField = () => {
  focusTextContentFieldFn?.();
};

export default focusTextContentField;
